/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserTeam } from './userTeam';
import { Practice } from './practice';
import { RoleEnum } from './roleEnum';
import { UserGroup } from './userGroup';


/**
 * Row of the users tab. Expects a queryset annotated with ``with_is_configured()``.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface UserList { 
    readonly id: number;
    name: string;
    email: string;
    readonly role: RoleEnum;
    readonly groups: Array<UserGroup>;
    readonly teams: Array<UserTeam>;
    readonly practices: Array<Practice>;
    /**
     * Legt fest, dass der Benutzer alle Berechtigungen hat, ohne diese einzeln zuweisen zu müssen.
     */
    isSuperuser?: boolean;
    readonly isConfigured: boolean;
    /**
     * Legt fest, ob dieser Benutzer aktiv ist. Kann deaktiviert werden, anstatt Benutzer zu löschen.
     */
    isActive?: boolean;
    readonly photoUrl: string | null;
}
export namespace UserList {
}

export const UserList_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserList_name_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(255),];

export const UserList_email_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.maxLength(254), Validators.email,];

export const UserList_role_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserList_groups_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserList_teams_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserList_practices_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserList_isSuperuser_Validators: ValidatorFn[] =
    [ ];

export const UserList_isConfigured_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const UserList_isActive_Validators: ValidatorFn[] =
    [ ];

export const UserList_photoUrl_Validators: ValidatorFn[] =
    [  Validators.required, ];


